import { ReactNode } from 'react';

import { Typography } from '@braskai/ui-kit';

import { TypographyProps } from '@mui/material';

type TypographyLinkProps = {
  children: ReactNode;
  href: string;
  rel?: string;
  target?: string;
} & Omit<TypographyProps, 'component'>;

export const TypographyLink = ({ children, href, rel = 'noopener noreferrer', target, ...props }: TypographyLinkProps) => {
  return (
    <Typography
      {...props}
      component="a"
      // @ts-expect-error - MUI Typography with component="a" doesn't properly type href
      href={href}
      rel={target === '_blank' ? rel : undefined}
      target={target}
    >
      {children}
    </Typography>
  );
};
